import { render, staticRenderFns } from "./SupplierRawMaterialComposition.vue?vue&type=template&id=2a5a0fc4&scoped=true&"
import script from "./SupplierRawMaterialComposition.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialComposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a0fc4",
  null
  
)

export default component.exports